import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { toastHelper } from '../util/toastHelper.js'

const API_VERSION = 'v1'
const API_VERSION_STAFF = 'v1'
const REQUEST_URL = `${process.env.REACT_APP_REQUEST_URL}/api/${API_VERSION}/vendor`
const REQUEST_URL_STAFF = `${process.env.REACT_APP_REQUEST_URL}/api/${API_VERSION_STAFF}/staff`


export const getVendors = createAsyncThunk(
	'getVendors',
	async (payload = {}) => {
		try {
			const queryString = new URLSearchParams(
				Object.entries(payload).filter(([_, value]) => !!value && value != null)
			).toString()

			const url = `${REQUEST_URL}/vendors-list${queryString ? `?${queryString}` : ''}`

			const res = await fetch(url, {
				method: 'GET',
				credentials: 'include',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})

			const data = await res.json()
			return data
		} catch (err) {
			console.error('Error fetching vendors:', err.message)
		}
	}
)

export const addVendorToKazoo = createAsyncThunk(
	'kazoo/addVendorToKazoo',
	async ({ kazooId, vendorId, vendorData }) => {
		try {
			const res = await fetch(`${REQUEST_URL}/add-vendor/${kazooId}`, {
				method: 'PATCH',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ vendorId, ...vendorData }),
			})

			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

// Invite vendors by email
export const inviteVendorsByEmail = createAsyncThunk(
	'kazoo/inviteVendorsByEmail',
	async ({ kazooId, emails, vendorData }) => {
		try {
			const payload = Array.isArray(emails)
				? { emails }
				: { email: emails }
			
			const res = await fetch(
				`${REQUEST_URL}/invite-vendors-by-email/${kazooId}`,
				{
					method: 'PATCH',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({...payload, ...vendorData}),
				}
			)

			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

export const getKazooVendors = createAsyncThunk(
	'kazoo/getKazooVendors',
	async (kazooId) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/get-kazoo-vendors/${kazooId}`,
				{
					method: 'GET',
					credentials: 'include',
					headers: {
						Accept: 'application/json',
						'Content-Type': 'application/json',
					},
				}
			)
			const result = await res.json()
			return result
		} catch (err) {
			console.log(err.message)
		}
	}
)

export const removeVendorFromKazoo = createAsyncThunk(
	'kazoo/removeVendorFromKazoo',
	async ({ kazooId, vendorId, email }) => {
		try {
			const res = await fetch(
				`${REQUEST_URL}/remove-vendor-from-kazoo/${kazooId}`,
				{
					method: 'PATCH',
					credentials: 'include',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify({ vendorId, email }),
				}
			)
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

/** NOTE:: Instead multiple network requests use @function inviteVendorStaffByEmails to send emails at once */
// export const inviteVendorStaffMultiple = createAsyncThunk(
// 	'kazoo/inviteVendorStaff',
// 	async (rowData) => {
// 		const emails = Array.from(
// 			new Set(
// 				(Array.isArray(rowData) ? rowData : [])
// 					.map((r) => (typeof r === 'string' ? r : r?.email))
// 					.filter(Boolean)
// 					.map((e) => String(e).trim().toLowerCase())
// 			)
// 		).slice(0, 10)

// 		if (!emails.length) return { results: [] }

// 		const results = []
// 		for (const email of emails) {
// 			try {
// 				const res = await fetch(`${REQUEST_URL_STAFF}/invite-staff`, {
// 					method: 'PATCH',
// 					credentials: 'include',
// 					headers: {
// 						'Content-Type': 'application/json',
// 					},
// 					body: JSON.stringify({ email }),
// 				})
// 				const data = await res.json().catch(() => ({}))
// 				results.push({ email, ok: res.ok && data?.success, data })
// 			} catch (err) {
// 				results.push({
// 					email,
// 					ok: false,
// 					data: { message: err.message || 'Request failed' },
// 				})
// 			}
// 		}

// 		return { results }
// 	}
// )

export const inviteVendorStaffByEmails = createAsyncThunk(
	'kazoo/inviteVendorStaffByEmails',
	async (rows) => {
		try {
			const res = await fetch(`${REQUEST_URL_STAFF}/invite-staff`, {
				method: 'PATCH',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ rows }),
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

export const getStaffInfo = createAsyncThunk(
	'vendor/getStaffInfo',
	async () => {
		try {
			const res = await fetch(`${REQUEST_URL_STAFF}/get-staff`, {
				method: 'GET',
				credentials: 'include',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

export const getVendorDashboard = createAsyncThunk(
	'vendor/getVendorDashboard',
	async () => {
		try {
			const res = await fetch(`${REQUEST_URL}/dashboard`, {
				method: 'GET',
				credentials: 'include',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error('Error fetching vendor dashboard:', err.message)
			throw err
		}
	}
)

export const removeVendorStaff = createAsyncThunk(
	'vendor/removeVendorStaff',
	async (id) => {
		try {
			const res = await fetch(`${REQUEST_URL_STAFF}/remove-staff/${id}`, {
				method: 'PATCH',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

export const getVendorFieldValues = createAsyncThunk(
	'vendor/getVendorFieldValues',
	async (payload = {}) => {
		try {
			const queryString = new URLSearchParams(
				Object.entries(payload).filter(([_, value]) => value != null)
			).toString()

			const url = `${REQUEST_URL}/field-values${queryString ? `?${queryString}` : ''}`

			const res = await fetch(url, {
				method: 'GET',
				credentials: 'include',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

export const updateStaffStatus = createAsyncThunk(
	'vendor/updateStaffStatus',
	async (payload) => {
		try {
			const { staffId, ...rest } = payload
			const res = await fetch(`${REQUEST_URL_STAFF}/update-status/${staffId}`, {
				method: 'PATCH',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
					Accept: 'application/json',
				},
				body: JSON.stringify(rest),
			})
			const data = await res.json()
			return data
		} catch (err) {
			console.error(err.message)
		}
	}
)

const initialState = {
	vendorSearchList: [],
	vendorSearchListLoading: false,
	vendorTotalPages: 0,
	vendorCurrentPage: 1,
	vendorTotalCount: 0,
	vendors: [],
	vendorFilters: { page: 1, limit: 10 },
	staff: [],
	vendorFieldValues: {},
}

const vendorSlice = createSlice({
	name: 'vendor',
	initialState,
	reducers: {
		setVendorFilters: (state, { payload }) => {
			state.vendorFilters = payload
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(getVendors.pending, (state) => {
				state.vendorSearchListLoading = true
				state.vendorSearchList = []
				state.vendorTotalPages = 0
				state.vendorCurrentPage = 1
				state.vendorTotalCount = 0
			})
			.addCase(getVendors.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to fetch for vendors',
						'error'
					)
					state.vendorSearchListLoading = false
					return
				}
				state.vendorSearchListLoading = false
				state.vendorSearchList= payload.vendors
				state.vendorTotalPages = payload.totalPages
				state.vendorCurrentPage = payload.currentPage
				state.vendorTotalCount = payload.totalCount
			})
			.addCase(getVendors.rejected, (state) => {
				state.vendorSearchListLoading = false
				state.vendorSearchList = []
				state.vendorTotalPages = 0
				state.vendorCurrentPage = 1
				state.vendorTotalCount = 0
			})

			.addCase(addVendorToKazoo.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload.message || 'Failed to add vendor to wedding',
						'error'
					)
					return
				}
				toastHelper(
					payload.message || 'Successfully added vendor to wedding',
					'success'
				)
				state.vendors = [...state.vendors, payload.vendor]
			})

			.addCase(getKazooVendors.fulfilled, (state, { payload }) => {
				const vendorKey = (v) =>
					v?._id
						? `id:${v._id}`
						: `email:${String(v?.email || '').toLowerCase()}`
				const mapVendors = (a = []) => {
					const map = new Map()
					a.forEach((v) => map.set(vendorKey(v), v))
					return Array.from(map.values())
				}
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to fetch wedding vendors',
						'error'
					)
					return
				}
				state.vendors = mapVendors(payload.vendors || [])
			})

			.addCase(inviteVendorsByEmail.fulfilled, (state, { payload }) => {
				const results = payload?.results || []

				results.forEach(({ email, success, message, vendor }) => {
					if (!success) {
						toastHelper(
							message || `Failed to invite ${email}`,
							'error'
						)
						return
					}
					toastHelper(
						message || `Invitation sent to ${email}`,
						'success'
					)

					if (vendor && vendor._id) {
						const byEmailIdx = state.vendors.findIndex(
							(v) =>
								(v.email || '').toLowerCase() ===
								String(
									email || vendor.email || ''
								).toLowerCase()
						)
						if (byEmailIdx !== -1) {
							state.vendors[byEmailIdx] = {
								...state.vendors[byEmailIdx],
								...vendor,
							}
							return
						}

						const byIdIdx = state.vendors.findIndex(
							(v) => v._id === vendor._id
						)
						if (byIdIdx !== -1)
							state.vendors[byIdIdx] = {
								...state.vendors[byIdIdx],
								...vendor,
							}
						else state.vendors.push(vendor)
					} else if (email) {
						const exists = state.vendors.some(
							(v) =>
								(v.email || '').toLowerCase() ===
								String(email).toLowerCase()
						)
						if (!exists)
							state.vendors.push({ email, status: 'sent' })
					}
				})
			})

			.addCase(removeVendorFromKazoo.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message ||
							'Could not remove vendor from wedding',
						'error'
					)
					return
				}
				toastHelper(
					payload.message ||
						'Successfully removed vendor from wedding',
					'success'
				)
				const identifier = payload.identifier
				state.vendors = state.vendors.filter(
					(vendor) =>
						vendor._id !== identifier && vendor.email !== identifier
				)
			})

			.addCase(
				inviteVendorStaffByEmails.fulfilled,
				(state, { payload }) => {
					if(!payload || !payload.success) {
						toastHelper(
							payload?.message || 'Failed to invite staff',
							'error'
						)
						return
					}

					toastHelper(
						payload?.message || 'Invitation sent to staff',
						'success'
					)
				}
			)

			.addCase(getStaffInfo.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to fetch staff',
						'error'
					)
					return
				}
				state.staff = payload.staff || []
			})

			.addCase(removeVendorStaff.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to remove staff',
						'error'
					)
					return
				}
				toastHelper(payload.message || 'Removed staff', 'success')
				const { staffId } = payload
				state.staff = (state.staff || []).filter(
					(s) => String(s.staffId) !== String(staffId)
				)
			})
			.addCase(getVendorFieldValues.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to fetch vendor field values',
						'error'
					)
					return
				}
				state.vendorFieldValues = {
					...state.vendorFieldValues,
					[payload.fieldName]: payload.values,
				}
			})
			.addCase(updateStaffStatus.fulfilled, (state, { payload }) => {
				if (!payload || !payload.success) {
					toastHelper(
						payload?.message || 'Failed to update staff status',
						'error'
					)
					return
				}
				toastHelper(payload.message || 'Updated staff status', 'success')
			})
	},
})

export const { setVendorFilters } = vendorSlice.actions

export default vendorSlice.reducer
